const validateLoginForm = (username, password) => {
  const errors = [];

  if (!username.trim()) {
    errors.push(loginVars.messages.emptyUsername);
  } else if (
    username.includes("@") &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)
  ) {
    errors.push(loginVars.messages.invalidEmail);
  }

  if (!password.trim()) {
    errors.push(loginVars.messages.emptyPassword);
  }

  return errors;
};

const handleLoginSubmit = async (form, type) => {
  const formMessage = form.querySelector(".form-message");
  if (!formMessage) {
    console.error("Form message element not found");
    return;
  }

  const username = form.querySelector('input[name="username"]').value;
  const password = form.querySelector('input[name="password"]').value;

  // Frontend validation
  const validationErrors = validateLoginForm(username, password);
  if (validationErrors.length > 0) {
    formMessage.textContent = validationErrors[0];
    formMessage.classList.remove("success");
    formMessage.classList.add("error");
    return;
  }

  try {
    const formData = new FormData(form);
    formData.append("action", "handle_login");
    formData.append("nonce", loginVars.nonce);

    const response = await fetch(loginVars.ajaxUrl, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
    });

    const data = await response.json();

    if (data.success) {
      formMessage.textContent = loginVars.messages.success;
      formMessage.classList.remove("error");
      formMessage.classList.add("success");

      // If we have a specific redirect URL, use it
      const redirectUrl = data.data.redirect || data.data.redirect_url;

      if (redirectUrl) {
        // Disable form inputs during redirect
        form
          .querySelectorAll("input, button")
          .forEach((el) => (el.disabled = true));

        // Perform redirect
        window.location.href = redirectUrl;
      } else {
        // Fallback to page reload if no redirect URL
        window.location.reload(true);
      }

      // Don't show any additional messages since we're redirecting
      return;
    } else {
      formMessage.textContent = data.data.message || loginVars.messages.error;
      formMessage.classList.remove("success");
      formMessage.classList.add("error");
    }
  } catch (error) {
    console.error("Login error:", error);
    formMessage.textContent = loginVars.messages.error;
    formMessage.classList.remove("success");
    formMessage.classList.add("error");
  }
};

export const initLoginForm = () => {
  const formHandlers = [
    { id: "page-login-form", type: "page" },
    { id: "offcanvas-login-form", type: "offcanvas" },
  ];

  formHandlers.forEach(({ id, type }) => {
    const form = document.getElementById(id);
    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        await handleLoginSubmit(form, type);
      });
    }
  });
};
